import React, { useCallback } from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ButtonTertiary } from 'ui';
import { ManageOptionsParams } from 'app/components/options-handler/types';

const ManageOptionsButton = ({manageOptions, textManageOptions, onClose}) => {
  const handleClick = useCallback(() => {
    onClose();
    navigate.toCodeList(undefined, manageOptions.codetableId, manageOptions.categoryId);
  },[manageOptions.codetableId, manageOptions.categoryId, onClose]);

  return (
    <ButtonTertiary onClick={handleClick}>{textManageOptions}</ButtonTertiary>
  );
};

export interface ExtraFooterParams {
  create: ManageOptionsParams; 
  codetableId: number;
}

export const manageOptionsButtonWrapper = (manageOptions: ExtraFooterParams, textManageOptions: string) => {
  
  return (onClose: () => void) => {
    return manageOptions.create &&
      <ManageOptionsButton {...{manageOptions}} {...{textManageOptions}} onClose={onClose}/>;
  };
};
